import React, { useState } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import styled from 'styled-components';
import {PRIMARY} from '../const/colors'
import { Link } from 'react-router-dom';
import {useDispatch} from 'react-redux';
import { setActivePage } from '../features/user/userSlice';
import { mobile_medium, mobile_normal } from '../const/fonts';
import { useTranslation } from 'react-i18next';
/* IMPORTAMOS LOS PDFS */
import terms from '../assets/pdfs/Terms & Conditions.pdf';
import terminos from '../assets/pdfs/Términos & Condiciones 2024 version GLI.pdf';
import policy from '../assets/pdfs/AML & KYC Policy.pdf';
import responsible from '../assets/pdfs/Responsible Gaming.pdf';
import privacy from '../assets/pdfs/Privacy Policy.pdf';
import exclusion from '../assets/pdfs/Self - Exclusion.pdf';
import equidad from '../assets/pdfs/Equity & RNG.pdf';
import acc from '../assets/pdfs/Accounts, Payments and Bonuses.pdf';
import dispute from '../assets/pdfs/Dispute Resolution.pdf';
//import privacidad from '../assets/pdfs/Política de Privacidad.pdf';
import generalRules from '../assets/pdfs/PERUVIAN SOFTWARE SOLUTIONS SAC reglas de juegos.pdf';
import privacidad from '../assets/pdfs/politica de privacidad y tratamiento de datos personales nov 2024.pdf';
const ExpandIcon = styled(ArrowDropDownIcon)`

  color: ${PRIMARY};
  //margin-right: -1rem;
`;

const StyledAccordion = styled(Accordion)`
  background-color: transparent !important;
  box-shadow: none !important;
  margin-bottom: 1rem;

  ::before {
    opacity: 0 !important;
  }

  @media screen and (max-width: 480px) {
    margin-bottom: 0;
  }
`;

const AccordionHeader = styled(AccordionSummary)`
  color: ${PRIMARY} !important;
  font-weight: bold !important;
  width: 75% !important;
  margin: 0 auto !important;
  padding: 0 !important;
  font-size: ${mobile_normal};

  .MuiAccordionSummary-expandIconWrapper {
    margin-right: -0.5rem;
  }
  .MuiAccordionSummary-content {
    padding-left: 0.25rem !important;
  }

`;

const AccordionContent = styled(AccordionDetails)`
  background: transparent;
  color: #fff;
  width: 80% !important;
  margin: 0 auto !important;

  > div {
    margin: 1rem 0.5rem !important;
  }
  > div a {
    font-size: ${mobile_medium};
  }
  /* @media screen and (max-width: 480px) {
    width: 90% !important;
  } */
`;

const CustomAccordion = ({data}) => {
  const [t, i18n] = useTranslation('global');
  const [expandedPanel, setExpandedPanel] = useState(false);
  const dispatch = useDispatch();

  const handleClick = (link) => {
    dispatch(setActivePage(link));
    const scrollfooter = document.getElementById("root");
    scrollfooter.scrollIntoView({ behavior: "smooth" });
  }
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  return (
    <div>
      <StyledAccordion expanded={expandedPanel === 'panel1'} onChange={handleAccordionChange('panel1')}>
        <AccordionHeader expandIcon={<ExpandIcon />}>
          {t(`footer.list-1-title`)}
        </AccordionHeader>

        <AccordionContent>
        {
              i18n.language!=='en' && <>
              <div><a href={terminos} target='_blank' rel='noreferrer'>{t(`footer.list-1.0.title`)}</a></div>
              <div><a href='https://admin.masterbets365.com/masterbets/policy/Policy-MasterBets365-1.pdf' target='_blank' rel='noreferrer'>{t(`footer.list-1.1.title`)}</a></div>
              <div><a href='https://admin.masterbets365.com/masterbets/policy/Juego Responsable.pdf' target='_blank' rel='noreferrer'>{t(`footer.list-1.2.title`)}</a></div>
              <div><a href={privacidad} target='_blank' rel='noreferrer'>{t(`footer.list-1.3.title`)}</a></div>
              <div><a href='https://admin.masterbets365.com/masterbets/policy/Autoexclusión.pdf' target='_blank' rel='noreferrer'>{t(`footer.list-1.4.title`)}</a></div>
              <div><a href='https://admin.masterbets365.com/masterbets/policy/Equidad y RNG.pdf' target='_blank' rel='noreferrer'>{t(`footer.list-1.5.title`)}</a></div>
              <div><a href='https://admin.masterbets365.com/masterbets/policy/Cuentas, Pagos y Bonificaciones.pdf' target='_blank' rel='noreferrer'>{t(`footer.list-1.6.title`)}</a></div>
              <div><a href='https://admin.masterbets365.com/masterbets/policy/Resolución de Conflictos.pdf' target='_blank' rel='noreferrer'>{t(`footer.list-1.7.title`)}</a></div>
              </>
            }
            {
              i18n.language==='en' && <>
              <div><a href={terms} target='_blank' rel='noreferrer'>{t(`footer.list-1.0.title`)}</a></div>
              <div><a href={policy} target='_blank' rel='noreferrer'>{t(`footer.list-1.1.title`)}</a></div>
              <div><a href={responsible} target='_blank' rel='noreferrer'>{t(`footer.list-1.2.title`)}</a></div>
              <div><a href={privacy} target='_blank' rel='noreferrer'>{t(`footer.list-1.3.title`)}</a></div>
              <div><a href={exclusion} target='_blank' rel='noreferrer'>{t(`footer.list-1.4.title`)}</a></div>
              <div><a href={equidad} target='_blank' rel='noreferrer'>{t(`footer.list-1.5.title`)}</a></div>
              <div><a href={acc} target='_blank' rel='noreferrer'>{t(`footer.list-1.6.title`)}</a></div>
              <div><a href={dispute} target='_blank' rel='noreferrer'>{t(`footer.list-1.7.title`)}</a></div>
              </>
            }
          {/* {
            data['list-1'].map((item, i) => <div key={`list-1-item-${i+1}`}><Link to={t(`footer.list-1.${i}.url`)} onClick={()=>handleClick(`footer.list-1.${i}.url`)}>{t(`footer.list-1.${i}.title`)}</Link></div>)
          } */}
        </AccordionContent>
      </StyledAccordion>

      <StyledAccordion expanded={expandedPanel === 'panel2'} onChange={handleAccordionChange('panel2')}>

        <AccordionHeader expandIcon={<ExpandIcon />}>
        {t(`footer.list-2-title`)}
        </AccordionHeader>

        <AccordionContent>
          {
            data['list-2'].map((item, i) => <div  key={`list-2-item-${i+1}`}><Link to={t(`footer.list-2.${i}.url`)}  onClick={()=>handleClick(`footer.list-2.${i}.url`)}>{t(`footer.list-2.${i}.title`)}</Link></div>)
          }
        </AccordionContent>
      </StyledAccordion>

      <StyledAccordion expanded={expandedPanel === 'panel3'} onChange={handleAccordionChange('panel3')}>

        <AccordionHeader expandIcon={<ExpandIcon />}>
        {t(`footer.list-3-title`)}
        </AccordionHeader>

        <AccordionContent>
          {
            data['list-3'].map((item, i) => <div key={`list-3-item-${i+1}`}><Link to={t(`footer.list-3.${i}.url`)}  onClick={()=>handleClick(`footer.list-3.${i}.url`)}>{t(`footer.list-3.${i}.title`)}</Link></div>)
          }
        </AccordionContent>

      </StyledAccordion>

      <StyledAccordion expanded={expandedPanel === 'panel4'} onChange={handleAccordionChange('panel4')}>

        <AccordionHeader expandIcon={<ExpandIcon />}>
        {t(`footer.list-4-title`)}
        </AccordionHeader>

        <AccordionContent>
          {
            data['list-4'].map((item, i) => <div key={`list-4-item-${i+1}`}><Link to={t(`footer.list-4.${i}.url`)} onClick={()=>handleClick(`footer.list-4.${i}.url`)}>{t(`footer.list-4.${i}.title`)}</Link></div>)
          } 
          <div><a href={generalRules} target='_blank' rel='noreferrer'>Reglamentos Generales</a></div>

        </AccordionContent>

      </StyledAccordion>

    </div>
  );
};

export default CustomAccordion;